import { Icon, Row, Col } from 'antd';

export default class extends React.Component {
    constructor(props) { super(props); }
    render() {
        return (
            <Row type='flex' justify='space-around' align='middle'>
                <Col>
                    <div className='afsp-login-form-unexpected-error'>
                        <div className='afsp-login-form-unexpected-error-title'>
                            <Icon type='warning' style={{ marginRight: '8px' }} />
                            <span>
                                {'An unexpected error has occured.'}
                            </span>
                        </div>
                        <div className='afsp-login-form-unexpected-error-info'>
                            {'Currently unable to log-in.'}
                        </div>
                    </div>
                </Col>
            </Row>
        )
    }
}